import * as tslib_1 from "tslib";
import { CustomerActionTypes } from './types';
import { settings } from '../../../settings';
import { store } from '../../../index';
import { ContextCreator } from '../../../websiteStateEngine/util/ContextCreator';
var requestMap = new Map();
var coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
export function coreRequest(request) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var protocol, context, mapKey, abortController, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    protocol = store.getState().websiteState.app.location.protocol;
                    if (request.body) {
                        context = ContextCreator.create(store.getState());
                        request.body = tslib_1.__assign({ context: context }, request.body);
                    }
                    mapKey = request.method + request.path;
                    if (requestMap.has(mapKey)) {
                        requestMap.get(mapKey).abort();
                    }
                    abortController = new AbortController();
                    requestMap.set(mapKey, abortController);
                    return [4 /*yield*/, fetch(protocol + '//' + coreBaseUrl + request.path, {
                            signal: abortController.signal,
                            headers: {
                                'accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            method: request.method,
                            credentials: 'include',
                            body: JSON.stringify(request.body)
                        })];
                case 1:
                    response = _a.sent();
                    requestMap.delete(mapKey);
                    return [2 /*return*/, response];
            }
        });
    });
}
export function login(formData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url, response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (window['singleSignOn']) {
                        url = new URL(location.href);
                        formData.referrer = decodeURIComponent(url.searchParams.get('referrer') || '');
                    }
                    return [4 /*yield*/, coreRequest({
                            method: 'POST',
                            path: '/user/login',
                            body: formData
                        })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    return [4 /*yield*/, getUserBookmarkInfo()];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4: return [2 /*return*/, response];
            }
        });
    });
}
export function logout() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/logout',
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    return [4 /*yield*/, getUserBookmarkInfo()];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4: return [2 /*return*/, response];
            }
        });
    });
}
export function register(formData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window['singleSignOn']) {
                        url = new URL(location.href);
                        formData.referrer = decodeURIComponent(url.searchParams.get('referrer') || '');
                    }
                    return [4 /*yield*/, coreRequest({
                            method: 'POST',
                            path: '/user/register',
                            body: formData
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, getUserBookmarkInfo()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
export function validateRegistration(formData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/validateRegistration',
                        body: formData
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function confirmEmail() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/confirmRegistration' + location.search,
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
export function requestUserDeletion() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'DELETE',
                        path: '/user/delete'
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function checkServiceToken() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'GET',
                        path: '/user/validateServiceToken' + location.search
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function requestPasswordReset(requestPassReset) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/requestPasswordReset',
                        body: requestPassReset
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function submitResetPassword(resetPasswordRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resetPasswordRequest.hash = new URLSearchParams(location.search).get('token') || '';
                    return [4 /*yield*/, coreRequest({
                            method: 'POST',
                            path: '/user/resetPassword',
                            body: resetPasswordRequest
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function validateResetPassword(resetPasswordRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/validateResetPassword',
                        body: resetPasswordRequest
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function changePassword(passwordChangeRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/changePassword',
                        body: passwordChangeRequest
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function validateNewPassword(passwordChangeRequest) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/validatePasswordChange',
                        body: passwordChangeRequest
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function loginAnonymous() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/anonymousLogin'
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function loginOrCreateAnonymousUser() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/loginOrCreateAnonymousUser'
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
export function userInfo() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'GET',
                        path: '/user/info'
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
export function updateUserData(data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/user/updateData',
                        body: data
                    })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.user = _c.sent(),
                            _b.type = CustomerActionTypes.CUSTOMER_LOGIN,
                            _b)]);
                    _c.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
export function getUserBookmarkInfo() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'GET',
                        path: '/bookmarks/v2/info'
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function addBookmarkList(name) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/bookmarks/v2/list',
                        body: { name: name }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    return [2 /*return*/, data.bookmarkListsOfUser[0]];
                case 3: return [2 /*return*/, null];
            }
        });
    });
}
export function addBookmark(giataId, bookmarkListId, additionalInfo) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'POST',
                        path: '/bookmarks/v2/hotel',
                        body: tslib_1.__assign({ bookmarkListId: bookmarkListId,
                            giataId: giataId }, additionalInfo)
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function removeBookmark(giataId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'DELETE',
                        path: '/bookmarks/v2/hotel',
                        body: {
                            giataId: giataId
                        }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function removeBookmarks(giataIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'DELETE',
                        path: '/bookmarks/v2/hotelsv2',
                        body: {
                            giataIds: giataIds
                        }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function cleanBookmarkList(listId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'DELETE',
                        path: '/bookmarks/v2/clean',
                        body: { id: listId }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function removeBookmarkList(listId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'DELETE',
                        path: '/bookmarks/v2/list',
                        body: { id: listId }
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function updateBookmarkList(bookmarkListData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, data;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreRequest({
                        method: 'PATCH',
                        path: '/bookmarks/v2/list',
                        body: bookmarkListData
                    })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    broadcastDispatch({
                        bookmarks: data.bookmarksOfUser,
                        bookmarkLists: data.bookmarkListsOfUser,
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getBookmarkedProducts(productRequest, bookmarkListId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response, _a, _b, _c;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    broadcastDispatch({
                        products: {
                            status: 'loading'
                        },
                        type: CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION
                    });
                    return [4 /*yield*/, coreRequest({
                            method: 'POST',
                            path: "/bookmarks/v2/productList?listId=" + bookmarkListId,
                            body: productRequest
                        })];
                case 1:
                    response = _d.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    _a = broadcastDispatch;
                    _b = {};
                    _c = [{}];
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [(_b.products = tslib_1.__assign.apply(void 0, _c.concat([(_d.sent()), { status: 'success' }])),
                            _b.type = CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION,
                            _b)]);
                    _d.label = 3;
                case 3: return [2 /*return*/, response];
            }
        });
    });
}
function broadcastDispatch(data) {
    store.dispatch(data);
    loginBroadcast.postMessage(data);
}
export var loginBroadcast = new BroadcastChannel('login_channel');
loginBroadcast.onmessage = function (message) { return store.dispatch(message.data); };
